<template>
  <div v-if="nodeInfos['id']" class="detail-panel un-tran">
    <!-- <div class="close"><i class="el-icon-close"></i></div> -->
    <div class="title-bar">
      {{ name }}
      <div class="tag">{{ tagInfoRelation[category] }}</div>
    </div>
    <div class="content">
      <div class="row">
        <label class="row-title">类型:</label>
        <span class="row-content">{{ tagInfoRelation[category] }}</span>
      </div>
      <div class="row" v-for="(item, index) of currentFields" :key="index">
        <label class="row-title">{{ item.label }}:</label>
        <span class="row-content">{{ tInfo[item.prop] }}</span>
      </div>
    </div>
    <div class="more" @click="openMore">查看更多<i class="el-icon-right"></i></div>
  </div>
</template>

<script>
import searchApi from '@/api/search.js'
import categoryFields from '../../components/advanced-search/config.json'
import { mapGetters } from 'vuex'
let tagInfoRelation = {
  bookMetaData: '文献',
  chartIndexData: '图表',
  personIndexData: '医家',
  geographyIndexData: '地理',
  prescriptionIndexData: '方剂',
  diseaseNameIndexData: '病名',
  chineseMedicineIndexData: '中药',
  meridianIndexData: '经络',
  acupointsIndexData: '腧穴',
  organizationIndexData: '机构',
  eventIndexData: '事件'
}

export default {
  data () {
    return {
      name: '',
      category: '',
      nodeInfos: {},
      tagInfoRelation,
      currentFields: []
    }
  },
  mounted () {
    this.$bus.$on('knowledgeNodeClick', info => {
      // console.log(info);
      this.category = info.categoryText
      this.name = info.name
      this.getData(info)
    })
  },
  computed: {
    ...mapGetters(['isTra']),
    tInfo () {
         return this.isTra ? JSON.parse(this.nodeInfos.originInfos) : this.nodeInfos
      }
  },
  methods: {
    getData (info) {
      searchApi
        .bookSearch({
          advacedFilters: JSON.stringify({
            category: info.categoryText,
            id: info.originId
          })
        })
        .then(res => {
          if (res.length > 0) {
            this.nodeInfos = res[0]
            this.currentFields = categoryFields[this.category]
          }
        })
    },
    openMore () {
      let url = window.location.origin + window.location.pathname
      this.$bus.$emit('openLogin', {
        url: `${url}#/literature?input=${this.name}&category=all&tcmGenreClassification=`
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.close {
  .font-size-extra-big;
  margin-left: 92%;
  margin-top: 4px;
  cursor: pointer;
}
.title-bar {
  width: 85%;
  margin-left: 7.5%;
  margin-top: 24px;
  padding-bottom: 16px;
  padding-left: 4px;
  display: flex;
  align-items: center;
  border-bottom: 2px solid #7c1823;
  color: #7c1823;
  font-size: 32px;

  .tag {
    padding: 4px 10px;
    .font-size-large;
    color: #f5f2eb;
    background-color: #7c1823;
    border-radius: 4px;
    margin-left: 24px;

    &.mini {
      .font-size-tiny;;
      padding: 3px 10px;
    }
  }
}
// @media screen and (min-width: 769px) {
  .detail-panel {
    width: 427px;
    height: 714px;
    position: absolute;
    margin-left: 1150px;
    margin-top: 90px;
    background-image: url("~@/assets/images/detail-panel.png");
    background-size: 100% 100%;
    font-family: "FangZhengKaiTi-GBK";

    .content {
      width: 85%;
      margin-left: 7.5%;
      height: 520px;
      margin-top: 16px;
      overflow: auto;

      .row {
        margin-bottom: 5px;
      }

      .row-title {
        .font-size-medium;
        font-weight: 600;
        // width: 100px;
        display: inline-block;
        margin-right: 1rem;
      }
    }

    .more {
      color: #7c1823;
      .font-size-medium;
      cursor: pointer;
      margin-left: 72%;
      margin-top: 16px;
    }
  }
// }
// @media screen and (max-width: 768px) {
//   .detail-panel {
//     width: 871px;
//     height: 870px;
//     // position: absolute;
//     // margin-left: 1150px;
//     background-image: url("~@/assets/images/detail-panel.png");
//     background-size: 100% 100%;
//     font-family: "FangZhengKaiTi-GBK";

//     .content {
//       width: 85%;
//       margin-left: 7.5%;
//       height: 680px;
//       margin-top: 16px;
//       overflow: auto;

//       .row {
//         margin-bottom: 5px;
// 		font-size: 32px;
//       }

//       .row-title {
//         font-size: 2.5rem;
//         font-weight: 600;
//         // width: 100px;
//         display: inline-block;
//         margin-right: 1rem;
//       }
//     }

//     .more {
//       color: #7c1823;
//       font-size: 32px;
//       cursor: pointer;
//       margin-left: 72%;
//       margin-top: 16px;
//     }
//   }
// }
</style>
